<template>
  <div class="data-center-page">

    <router-view></router-view>
  </div>
</template>

<script>
import { TABNAMES } from "./constants";
export default {
  name: "fundDetails",
  data() {
    return {};
  },
  computed: {
    tabName() {
      return TABNAMES[this.$route.path];
    },
  },
  created() {
  }
};
</script>

<style scoped>
.bread-tab {
  font-size: 16px;
}
.bd {
  font-weight: bold;
}
</style>
<style lang="less">
.data-center-page {
  .el-table {
    th,
    td {
      padding: 12px 10px;
    }
    td {
      word-break: break-word;
    }
    .cell {
      padding: 0px;
      line-height: normal;
    }
  }
}
</style>
